
export default function CTA() {
  return (
    <section id="appointment" className="relative py-32 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/622f1c6eb485313c6c45e9ad448ffa5a.jpg"
          alt="康顧專業顧問團隊"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/45 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center w-full">
        <div className="inline-flex items-center space-x-2 mb-6">
          <i className="ri-building-line text-orange-400 text-2xl"></i>
          <span className="text-orange-400 font-bold tracking-widest text-sm uppercase">院舍營運者的專業夥伴</span>
        </div>
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
          提升院舍服務質素<br />
          <span className="text-orange-400">由康顧全力支援</span>
        </h2>

        <p className="text-xl text-white/90 mb-10 leading-relaxed">
          無論是復康外展人手、智能器材採購，還是院舍改善工程，<br />
          康顧的專業顧問團隊為您度身訂造最合適的解決方案。
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-8">
          <a
            href="/contact#inquiry-form"
            className="group inline-flex items-center px-10 py-5 bg-orange-500 text-white text-lg font-bold rounded-full hover:bg-orange-600 transition-all duration-300 shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer"
          >
            <div className="w-10 h-10 flex items-center justify-center bg-white rounded-full mr-4">
              <i className="ri-mail-send-line text-orange-500 text-xl"></i>
            </div>
            <span>預約免費諮詢</span>
            <i className="ri-arrow-right-line text-2xl ml-3 group-hover:translate-x-1 transition-transform"></i>
          </a>
          <a
            href="tel:24015938"
            className="inline-flex items-center px-10 py-5 bg-white/15 border-2 border-white text-white text-lg font-bold rounded-full hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <div className="w-10 h-10 flex items-center justify-center mr-4">
              <i className="ri-phone-line text-2xl"></i>
            </div>
            <span>2401 5938</span>
          </a>
        </div>
      </div>
    </section>
  );
}
